import React from "react";
import { ReactComponent as RogIcon } from "../assets/icons/rog.svg";
import { ReactComponent as GencoinGemsIcon } from "../assets/gencoin-gems.svg";

function ROG() {
  const potentialPoints = [
    "Each vault can cycle infinitely",
    "There's no limit to how many vaults you can collect",
    "Higher gem tiers unlock even more Gencoin earning potential",
  ];

  return (
    <section>
      <div
        className="flex w-full max-w-6xl mx-auto px-4 sm:px-6 items-center"
        data-aos-id-gen-method-anchor
      >
        <div className="border-t border-gray-800">
          <div className="">
            {/* Mobile */}
            <div className="md:hidden flex flex-col items-center mt-10">
              <div
                className="flex flex-col items-center mb-10"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="flex justify-center" data-aos="fade-up">
                  <GencoinGemsIcon className="w-full text-primary-1 fill-current" />
                </div>

                <div className="flex flex-col text-center items-center justify-center mt-10">
                  <div className="h1 mb-6 text-xxl text-white">
                    Earn While You Give
                  </div>
                  <p className="text-3xl text-white mb-8">
                    Starting with just a{" "}
                    <span className="font-bold text-white">$5</span> gem
                    purchase to support another user's goal, you'll earn a new
                    vault that generates 10 Gencoin{" "}
                    <span className="font-bold text-white">
                      ($10 USD value)
                    </span>{" "}
                    when it fills with gems from the community. And the
                    potential only grows from there:
                  </p>

                  <ul className="text-3xl text-white mb-8 space-y-4 list-none pl-4">
                    {potentialPoints.map((point, index) => (
                      <li
                        key={index}
                        className="flex items-start justify-start text-left"
                      >
                        <span className="text-primary-1 mr-2">•</span>
                        {point}
                      </li>
                    ))}
                  </ul>

                  <p className="text-3xl text-primary-1 font-bold mb-6 italic">
                    Your potential grows with each act of generosity.
                  </p>
                </div>
              </div>
            </div>

            {/* Desktop and Tablet */}
            <div className="hidden md:flex flex-col w-full mt-20">
              <div
                className="flex mb-36"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="flex flex-col w-1/2 items-start justify-center">
                  <div className="h1 mb-6 text-xxl text-white">
                    Earn While You Give
                  </div>
                  <p className="text-3xl text-white mb-8">
                    Starting with just a{" "}
                    <span className="font-bold text-white">$5</span> gem
                    purchase to support another user's goal, you'll earn a new
                    vault that generates 10 Gencoin{" "}
                    <span className="font-bold text-white">
                      ($10 USD value)
                    </span>{" "}
                    when it fills with gems from the community. And the
                    potential only grows from there:
                  </p>

                  <ul className="text-3xl text-white mb-8 space-y-4 list-none pl-4">
                    {potentialPoints.map((point, index) => (
                      <li key={index} className="flex items-start">
                        <span className="text-primary-1 mr-2">•</span>
                        {point}
                      </li>
                    ))}
                  </ul>

                  <p className="text-3xl text-primary-1 font-bold mb-6 italic">
                    Your potential grows with each act of generosity.
                  </p>
                </div>
                <GencoinGemsIcon className="w-1/2 text-primary-1 fill-current ml-12" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ROG;
